import type { Command } from '../../types/commands'
import { addSessionDirectory, sessionNodeExists } from '../sessionFilesystem'
import { getContextDefaults } from '../../utils/contextUtils'

export const mkdirCommand: Command = {
  name: 'mkdir',
  description: 'Create a new directory',
  usage: 'mkdir <dirname>',
  category: 'system',
  acceptsFiles: false,
  acceptsDirectories: true,
  execute: (args, context) => {
    if (args.length === 0) {
      return [
        {
          type: 'error',
          content: 'mkdir: missing operand\nUsage: mkdir <dirname>',
        },
      ]
    }

    const dirname = args[0]
    const { currentDirectory, sessionFs } = getContextDefaults(context)

    // Validate dirname
    if (dirname.includes('/')) {
      return [
        {
          type: 'error',
          content: `mkdir: cannot create '${dirname}': Paths not supported (use simple directory names)`,
        },
      ]
    }

    if (dirname.startsWith('.')) {
      return [
        {
          type: 'error',
          content: `mkdir: cannot create '${dirname}': Hidden directories not allowed`,
        },
      ]
    }

    // Check if directory already exists
    const fullPath = currentDirectory === '~' ? dirname : `${currentDirectory}/${dirname}`
    const exists = sessionNodeExists(sessionFs, fullPath)

    if (exists) {
      return [
        {
          type: 'error',
          content: `mkdir: cannot create directory '${dirname}': File or directory already exists`,
        },
      ]
    }

    // Create directory
    const newFs = addSessionDirectory(sessionFs, currentDirectory, dirname)
    context?.setSessionFilesystem(newFs)

    return [
      {
        type: 'success',
        content: `Created directory: ${dirname}`,
      },
    ]
  },
}
